/** Ignore map clicks that are really pans. */
export const PARCEL_CLICK_MAX_MOVE_PX = 4;

/** Fingers roll during a tap, so touch needs far more slop than a mouse. */
export const PARCEL_TAP_MAX_MOVE_PX = 25;

/** Longer presses are holds or slow pans, not taps. */
export const PARCEL_TAP_MAX_MS = 600;

export function isTapNotDrag(start, end, maxMove = PARCEL_CLICK_MAX_MOVE_PX) {
  if (!start || !end) return true;
  const dx = Number(end.x) - Number(start.x);
  const dy = Number(end.y) - Number(start.y);
  if (!Number.isFinite(dx) || !Number.isFinite(dy)) return true;
  return (dx * dx) + (dy * dy) <= maxMove * maxMove;
}

/** Touch equivalent of isTapNotDrag: tolerates finger roll, rejects holds. */
export function isParcelTouchTap(start, end, elapsedMs) {
  if (!start || !end) return false;
  if (!Number.isFinite(Number(elapsedMs)) || Number(elapsedMs) > PARCEL_TAP_MAX_MS) return false;
  return isTapNotDrag(start, end, PARCEL_TAP_MAX_MOVE_PX);
}
